/**
 * SA-1077 (spec D2): the ONE rule for what opening the viewer's task does —
 * read by the band's primary button and the Tasks section's Current task block, so the two
 * cannot drift. A wait worked on the record (SA-394's `WAIT_SURFACES`) opens
 * its section in place; anything else is the task page with the origin state
 * the caller adds. Pure.
 */
import type { RecordProcessRead, TaskRead } from '@/types/process'
import { RECORD_RESULT } from '@/components/orders/feasibilityText'
import { taskPath } from '@/components/process/taskLink'
import { isFeasibilityWait } from './feasibilityAwait'

export const QUOTES_SURFACE = 'record.quotes'

export const OPEN_TASK = 'Open task'
export const RECORD_QUOTE = 'Prepare quote'
export const RECORD_RESPONSE = 'Record response'
export const QUOTE_VERSIONS = 'Quote versions'

export type OpenTaskAction =
  | { kind: 'panel'; panel: 'feasibility' | 'quotes'; label: string }
  | { kind: 'task'; to: string; label: string }

/** The first open task THIS viewer can open (SA-480's `can_open`), on a running process. */
export function firstOpenable(record: RecordProcessRead | null | undefined): TaskRead | null {
  if (!record || record.status !== 'running') return null
  return record.open_tasks.find((t) => t.can_open) ?? null
}

function quotesLabel(record: Pick<RecordProcessRead, 'current_step'> | null, task: TaskRead): string {
  const step = record?.current_step
  if (!step || step.id !== task.step_id) return QUOTE_VERSIONS
  if (step.waiting_for_event === 'quote_version_sent') return RECORD_QUOTE
  if (step.waiting_for_event === 'quote_response_recorded') return RECORD_RESPONSE
  return QUOTE_VERSIONS
}

export function openTaskAction(task: TaskRead, record: Pick<RecordProcessRead, 'current_step'> | null): OpenTaskAction {
  if (isFeasibilityWait(task)) return { kind: 'panel', panel: 'feasibility', label: RECORD_RESULT }
  if (task.kind === 'wait' && task.surface === QUOTES_SURFACE) return { kind: 'panel', panel: 'quotes', label: quotesLabel(record, task) }
  return { kind: 'task', to: taskPath(task.id), label: OPEN_TASK }
}
